import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { EnumRunControlState } from '../enums/run-control-state.enum';
import { IHITLRequest } from '../interfaces/hitl.interface';
import { ChatActivitiesStore } from './chat-activities.store';
import { ChatMessagesStore } from './chat-messages.store';

/** Estado pertencente à conversa, independente da tela selecionada. */
export class ChatSessionSlice {
  readonly messages = new ChatMessagesStore();
  readonly activities = new ChatActivitiesStore();
  readonly title = new BehaviorSubject<string | null>(null);
  readonly runControl = new BehaviorSubject<EnumRunControlState>(
    EnumRunControlState.IDLE
  );
  readonly isTyping = new BehaviorSubject(false);
  readonly interrupt = new BehaviorSubject<IHITLRequest | null>(null);
  readonly connection = new BehaviorSubject<
    'idle' | 'connected' | 'recovering' | 'disconnected'
  >('idle');
  loaded = false;

  clear(): void {
    this.messages.clear();
    this.activities.clear();
    this.title.next(null);
    this.runControl.next(EnumRunControlState.IDLE);
    this.isTyping.next(false);
    this.interrupt.next(null);
    this.connection.next('idle');
    this.loaded = false;
  }
}

/** Registro de dados. Transporte e retenção pertencem à camada de aplicação. */
@Injectable({ providedIn: 'root' })
export class ChatSessionsStore {
  private sessions = new Map<string, ChatSessionSlice>();

  ensureSession(sessionId: string): ChatSessionSlice {
    if (!sessionId) {
      throw new Error('A conversation requires a sessionId.');
    }
    let session = this.sessions.get(sessionId);
    if (!session) {
      session = new ChatSessionSlice();
      this.sessions.set(sessionId, session);
    }
    return session;
  }

  getSession(sessionId: string): ChatSessionSlice | undefined {
    return this.sessions.get(sessionId);
  }

  removeSession(sessionId: string): void {
    this.sessions.get(sessionId)?.clear();
    this.sessions.delete(sessionId);
  }

  clear(): void {
    this.sessions.forEach((session) => session.clear());
    this.sessions.clear();
  }
}
